<img class="logo" *ngIf="xtensaBasica" src="../../../../assets/XtensaBasica.png" />
<img class="logo" *ngIf="xtensaAmpliada" src="../../../../assets/XtensaAMPLIADA.png" />
<img class="logo" *ngIf="!xtensaBasica && !xtensaAmpliada" src="../../../../assets/blanco@3x.png" />
